import { AlertTriangle, ArrowLeft, Home } from "lucide-react";
import { Button } from "@/components/ui/button";

export const NotFoundPage = () => (
  <div className="min-h-screen bg-background flex items-center justify-center p-4">
    <div className="text-center max-w-md" data-testid="not-found-page">
      <div className="w-20 h-20 rounded-2xl bg-amber-500/10 flex items-center justify-center mx-auto mb-6">
        <AlertTriangle className="h-10 w-10 text-amber-500" />
      </div>
      <h1 className="text-4xl font-bold mb-2">404</h1>
      <h2 className="text-lg font-semibold mb-3 text-muted-foreground">Page Not Found</h2>
      <p className="text-sm text-muted-foreground mb-8">The page you're looking for doesn't exist or has been moved.</p>
      <Button onClick={() => window.location.href = '/'} className="gap-2" data-testid="go-home-btn">
        <Home className="h-4 w-4" />Back to Opero Smart
      </Button>
    </div>
  </div>
);
